var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#190933;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,50a5,5,0,0,0,4,4.9V61a3,3,0,0,0,3,3H53a3,3,0,0,0,3-3V7a3,3,0,0,0-3-3H52V3a3,3,0,0,0-3-3H9A3,3,0,0,0,6,3V7.1a5,5,0,0,0,0,9.8v9.2a5,5,0,0,0,0,9.8v9.2A5,5,0,0,0,2,50ZM53,6a1,1,0,0,1,1,1V61a1,1,0,0,1-1,1H52V6ZM39.5,2h5v9a.6.6,0,0,1-.31.55.42.42,0,0,1-.45,0l-.89-.65a1.44,1.44,0,0,0-1.7,0l-.89.65a.42.42,0,0,1-.45,0A.6.6,0,0,1,39.5,11ZM4,31a3,3,0,0,1,2-2.82V31a1,1,0,0,0,2,0V16.9A5,5,0,0,0,12,12a1,1,0,0,0-2,0A3,3,0,1,1,6,9.18V12a1,1,0,0,0,2,0V3A1,1,0,0,1,9,2h5V5a1,1,0,0,0,2,0V2H38.5v9a1.61,1.61,0,0,0,.85,1.44,1.41,1.41,0,0,0,1.5-.13l.89-.65a.45.45,0,0,1,.52,0l.89.65a1.43,1.43,0,0,0,.85.29,1.39,1.39,0,0,0,.65-.16A1.61,1.61,0,0,0,45.5,11V2H49a1,1,0,0,1,1,1V62H9a1,1,0,0,1-1-1V54.9A5,5,0,0,0,12,50a1,1,0,0,0-2,0,3,3,0,1,1-4-2.82V50a1,1,0,0,0,2,0V35.9A5,5,0,0,0,12,31a1,1,0,0,0-2,0,3,3,0,0,1-6,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,22a1,1,0,0,0,1-1V17a1,1,0,0,0-2,0v4A1,1,0,0,0,15,22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,14a1,1,0,0,0,1-1V9a1,1,0,0,0-2,0v4A1,1,0,0,0,15,14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,46a1,1,0,0,0,1-1V41a1,1,0,0,0-2,0v4A1,1,0,0,0,15,46Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,61V57a1,1,0,0,0-2,0v4a1,1,0,0,0,2,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,30a1,1,0,0,0,1-1V25a1,1,0,0,0-2,0v4A1,1,0,0,0,15,30Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,54a1,1,0,0,0,1-1V49a1,1,0,0,0-2,0v4A1,1,0,0,0,15,54Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,38a1,1,0,0,0,1-1V33a1,1,0,0,0-2,0v4A1,1,0,0,0,15,38Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,35a8,8,0,1,0-8-8A8,8,0,0,0,33,35Zm0-14a6,6,0,1,1-6,6A6,6,0,0,1,33,21Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.5,27A3.5,3.5,0,0,1,33,23.5a.5.5,0,0,0,0-1A4.51,4.51,0,0,0,28.5,27a.5.5,0,0,0,1,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,47H44a3,3,0,0,0,3-3V39.12a4,4,0,0,0-2.46-3.69,16.06,16.06,0,0,1-2.44-1.26,2,2,0,0,0-2.41.25,10,10,0,0,1-13.38,0,2,2,0,0,0-2.41-.25,16.06,16.06,0,0,1-2.44,1.26A4,4,0,0,0,19,39.12V44A3,3,0,0,0,22,47Zm-1-7.88a2,2,0,0,1,1.23-1.84A22.64,22.64,0,0,0,25,35.9a11.92,11.92,0,0,0,16.07,0,18.51,18.51,0,0,0,2.73,1.41h0A2,2,0,0,1,45,39.12V44a1,1,0,0,1-1,1H22a1,1,0,0,1-1-1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,50.5H24a.5.5,0,0,0,0,1H42a.5.5,0,0,0,0-1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,54.5H28a.5.5,0,0,0,0,1H38a.5.5,0,0,0,0-1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/Number.c0135b54.svg";
export { ForwardRef as ReactComponent };